import { Component, ChangeDetectionStrategy, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { Store } from '@ngrx/store';

import { IAppState } from '@app/store';
import { PageService } from '@app/core/content/services';
import * as SellerRatingActions from '@app/landings/store/actions';
import * as fromDataLayer from '@app/analytics/actions/data-layer';
import { TrackingClickPositions } from '@app/analytics/models/mapping';

export const pathToLocales = {
  'en-US': '/seller-badges/',
  'en-GB': '/seller-badges/',
  'fr-FR': '/vendeur-badges/',
  'de-DE': '/verkaufer-abzeichen/',
  'it-IT': '/venditori-attestato/',
  'es-ES': '/vendedores-insignias/'
};

@Component({
  selector: 'vc-seller-rating-page',
  templateUrl: './seller-rating-page.component.html',
  styleUrls: ['./seller-rating-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerRatingPageComponent implements OnInit {
  public readonly trackingClickPositions = TrackingClickPositions;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private pageService: PageService,
    private store: Store<IAppState>,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.setRoute();
  }

  setRoute() {
    this.route.data.subscribe(
      ({ pageAnalytics }) => {
        if (pageAnalytics) {
          this.store.dispatch(new fromDataLayer.Persist(pageAnalytics));
        }
      },
      () => {}
    );
    if (isPlatformServer(this.platformId)) {
      this.pageService.setLanguageVersions(pathToLocales);
    }
  }

  trackSellButtonClick(position) {
    this.store.dispatch({
      type: SellerRatingActions.SELLERRATING_CLICK_SELL_BUTTON,
      payload: { sell_cta_position: position }
    });
  }
}
